//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'UiFocusContainer',

  props: {
    containFocus: {
      type: Boolean,
      default: true,
    },
    focusRedirector: Function,
    disabled: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: 'div',
    },
    lazy: {
      type: Boolean,
      default: false, // When true, the focus redirectors are not rendered until containFocus is true
    },
  },

  computed: {
    renderRedirector() {
      if (this.disabled) {
        return false;
      }

      return this.lazy ? this.containFocus : true;
    },
  },

  methods: {
    /**
     * @public
     */
    focus() {
      this.$refs.content.focus();
    },

    redirectFocus(e, options) {
      if (!this.containFocus) {
        this.$emit('focus-overflow', e, options);
        return;
      }

      e.stopPropagation();

      if (this.focusRedirector) {
        this.focusRedirector(e, options);
        return;
      }

      if (options.isTabbingForward) {
        this.$refs.content.focus();
      } else {
        this.$refs.lastFocusable.focus();
      }
    },
  },
};

